export const RESUME_ACCEPT = [
  '.pdf',
  '.doc',
  '.docx',
  '.rtf',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/rtf',
  'text/rtf',
].join(',');

export const RESUME_MAX_BYTES = 10 * 1024 * 1024;

const ALLOWED_EXTENSIONS = ['pdf', 'doc', 'docx', 'rtf'];

const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/rtf',
  'text/rtf',
];

export function getResumeExtension(file) {
  if (!file?.name) return '';
  const parts = file.name.split('.');
  if (parts.length < 2) return '';
  return parts.pop().toLowerCase();
}

export function isValidResumeFile(file) {
  if (!file) {
    return { valid: false, reason: 'empty' };
  }
  if (file.size === 0) {
    return { valid: false, reason: 'empty' };
  }
  if (file.size > RESUME_MAX_BYTES) {
    return { valid: false, reason: 'size' };
  }

  const ext = getResumeExtension(file);
  const mime = (file.type || '').toLowerCase();

  if (ext && ALLOWED_EXTENSIONS.includes(ext)) {
    return { valid: true, reason: null };
  }

  if (mime && ALLOWED_MIME_TYPES.includes(mime)) {
    return { valid: true, reason: null };
  }

  return { valid: false, reason: 'type' };
}

export function resumeValidationMessage(reason) {
  if (reason === 'size') {
    return 'Resume must be 10 MB or smaller.';
  }
  if (reason === 'empty') {
    return 'The selected file is empty. Choose a different resume.';
  }
  return 'Please upload PDF, DOC, DOCX or RTF (max 10 MB).';
}

function slugifyName(name) {
  return String(name || 'user')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40) || 'user';
}

export function buildResumeS3Key(displayName, file) {
  const ext = getResumeExtension(file) || 'pdf';
  const d = new Date();
  const month = d.getMonth() + 1;
  const day = d.getDate();
  const currentDate = `${d.getFullYear()}/${month < 10 ? '0' : ''}${month}/${day < 10 ? '0' : ''}${day}`;
  const timestamp = Math.floor(Date.now() / 1000);
  const safeName = slugifyName(displayName);
  return `resume/${currentDate}/${safeName}-${timestamp}.${ext}`;
}
